<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Create repairable device') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-purple" to="/admin/repairable-devices">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <form @submit.prevent="saveRepairableDevice">
          <loading :status="loading.create"></loading>
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Repairable device information') }}
              </h3>
              <p class="form-description-text">{{ $t('Enter information for new repairable device') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="brand">{{ $t('Brand') }}</label>
                  <div class="pt-1 relative rounded-md shadow-sm">
                    <select class="form-input bg-white" id="brand" required v-model="device.brand_id">
                      <option :value="null" disabled>
                        {{ $t('Select an option') }}
                      </option>
                      <option :key="index" :value="brand.id" v-for="(brand, index) in brandList">
                        {{ brand.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="name">{{ $t('Name') }}</label>
                  <div class="pt-1 relative rounded-md shadow-sm">
                    <input :placeholder="$t('Name')" class="form-input" id="name" required v-model="device.name" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="model">{{ $t('Model') }}</label>
                  <div class="pt-1 relative rounded-md shadow-sm">
                    <input :placeholder="$t('Model')" class="form-input" id="model" required v-model="device.model" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="avatar">{{ $t('Image') }}</label>
                  <image-input :remove="false" id="avatar" v-model="image"></image-input>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/repairable-devices">{{ $t('Close') }}</router-link>
              <button class="btn btn-green shadow-sm rounded-md" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading.import"></loading>
        <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
          <div class="md:col-span-1">
            <h3 class="form-description-head">
              {{ $t('Batch entries with CSV import') }}
            </h3>
            <p class="form-description-text">
              {{ $t('Upload file for batch entries') }}.
              <br />
              {{ $t('A file should be CSV with format') }}.
              <br />
              {{ $t('A file must have only columns with title of') }}
              <span class="text-red-600">"name","model"</span>
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="brand">{{ $t('Brand') }}</label>
                <div class="pt-1 relative rounded-md shadow-sm">
                  <select class="form-input bg-white" id="brand" required v-model="brand_id">
                    <option :value="null" disabled>
                      {{ $t('Select a brand for imported devices') }}
                    </option>
                    <option :key="index" :value="brand.id" v-for="(brand, index) in brandList">
                      {{ brand.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="name">{{ $t('Excel CSV file') }}</label>
                <div class="pt-1 relative rounded-md shadow-sm">
                  <input @change="onChangeFileUpload" class="form-input" ref="file" required type="file" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="inline-flex">
            <button @click="importDevices" class="btn btn-blue shadow-sm rounded-md" type="submit">
              {{ $t('Upload') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('Create repairable device'),
    };
  },
  data() {
    return {
      loading: {
        create: false,
        import: false,
      },
      brandList: [],
      defects: [],
      image: { file: null, preview: null },
      device: {
        name: null,
        model: null,
        brand_id: null,
      },
      brand_id: null,
      file: null,
    };
  },
  mounted() {
    this.getBrands();
  },
  methods: {
    importDevices() {
      this.loading.import = true;
      const formData = new FormData();
      formData.append('file', this.file);
      if (this.brand_id) {
        formData.append('brand_id', this.brand_id);
      }
      axios
        .post(route('devices.import'), formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          this.loading.import = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/repairable-devices');
        })
        .catch(() => {
          this.loading.import = false;
        });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    getBrands() {
      this.loading.create = true;
      axios
        .get(route('brand.list'))
        .then((response) => {
          this.brandList = response.data;
          this.loading.create = false;
        })
        .catch(() => {
          this.loading.create = false;
        });
    },
    saveRepairableDevice() {
      this.loading.create = true;
      const formData = new FormData();
      formData.append('name', this.device.name);
      formData.append('model', this.device.model);
      formData.append('brand_id', this.device.brand_id);
      if (this.image.file) {
        formData.append('avatar', this.image.file);
      }
      axios
        .post(route('devices.store'), formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          this.loading.create = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push(`/admin/repairable-devices/${response.data.device.id}/edit`);
        })
        .catch(() => {
          this.loading.create = false;
        });
    },
  },
};
</script>
